import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Signatories from './components/Signatories';

import { Button, InfoBox } from 'hosman-material';
import { S_UserPlus } from 'hosman-material';

import { updateSalesUser } from '../../../../../../../../../reducers/SellerApp/salesUsersSlice';

const SignatoriesModule = () => {
  const { sale } = useSelector((state) => state.sellerSales);
  const dispatch = useDispatch();

  return (
    <div className='flex flex-col gap-8' id='SignatoriesModule' data-testid='SignatoriesModule'>
      <div className='flex flex-col md:flex-row md:justify-between items-center'>
        <p className='h3 text-ih-indigo'>Signataire(s) du mandat</p>
        <Button label='Ajouter un signataire' type='secondary' onClick={() => dispatch(updateSalesUser({ signatory: true }))} icon={S_UserPlus} />
      </div>

      <InfoBox avatarSrc={sale.expert?.user?.profile_pic_url}>
        <p>Tous les signataires ajoutés ci-dessous recevront une invitation par e-mail pour signer le mandat (une fois que vous l'aurez signé), et auront un accès propre à l'espace vendeur pour suivre la vente.</p>
      </InfoBox>

      <Signatories />
    </div>
  );
}

export default SignatoriesModule;
